export default {
    methods: {
        ehLei14_133(amparoLegal) {
            let lei = amparoLegal && amparoLegal.lei
            return !!(lei && lei.includes('14.133/2021'))
        },
        ehLei13_303(amparoLegal){
            let lei = amparoLegal && amparoLegal.lei
            return !!(lei && lei.includes('13.303/2016'))
        },
    }
}